import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { AppStore } from '../store';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const appStore = inject(AppStore);

  if (appStore.auth.authToken()) {
    req = req.clone({
      setHeaders: {
        Authorization: `${appStore.auth.authToken()}`,
      },
    });
  }

  if (req.headers.get('NoAuth')) {
    req = req.clone({
      setHeaders: {
        Authorization: '',
      },
    });
  }

  return next(req);
}
